// src/common/utils/dynamicTablePermissions.ts

interface DynamicTableActionPermissions<T> {
  showActions: {
    edit: boolean | string | ((record: T) => boolean);
    view?: boolean | string | ((record: T) => boolean);
    delete: boolean | string | ((record: T) => boolean);
  };
  addNewPermission: string;
  searchPermission: string; // New property for search permission
}

export const getDynamicTableActionPermissions = <T>(resourceName: string): DynamicTableActionPermissions<T> => {
  return {
    showActions: {
      edit: `${resourceName}.Update`,
      view: `${resourceName}.View`,
      delete: `${resourceName}.Delete`,
    },
    addNewPermission: `${resourceName}.Save`,
    searchPermission: `${resourceName}.Search`, // Set search permission
  };
};